import classNames from 'classnames';
import { t } from "../i18n";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/spinner/).
 */
export const Spinner = props => {
  const className = classNames('ds-c-spinner', props.size && `ds-c-spinner--${props.size}`, props.inversed && 'ds-c-spinner--inverse', props.filled && 'ds-c-spinner--filled', props.className);
  return /*#__PURE__*/_jsx("span", {
    className: className,
    role: props.role,
    children: /*#__PURE__*/_jsx("span", {
      className: "ds-u-visibility--screen-reader",
      children: props['aria-valuetext'] ?? t('spinner.ariaText')
    })
  });
};
Spinner.defaultProps = {
  role: 'status'
};
export default Spinner;